var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChart = function SvgChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#272E35",
    fillRule: "evenodd",
    d: "M.8 3A2.2 2.2 0 0 1 3 .8h10A2.2 2.2 0 0 1 15.2 3v10a2.2 2.2 0 0 1-2.2 2.2H3A2.2 2.2 0 0 1 .8 13zM3 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm5 2a.6.6 0 0 1 .6.6v6.8a.6.6 0 1 1-1.2 0V4.6A.6.6 0 0 1 8 4M5.4 6.4A.6.6 0 0 1 6 7v4.4a.6.6 0 1 1-1.2 0V7a.6.6 0 0 1 .6-.6M10.6 8a.6.6 0 0 1 .6.6v2.8a.6.6 0 1 1-1.2 0V8.6a.6.6 0 0 1 .6-.6",
    clipRule: "evenodd"
  })));
};
export default SvgChart;